module.exports = __webpack_public_path__ + "img/plan3_girl.2088b3ea.png";